module.exports = __webpack_public_path__ + "img/facilityInfo_3_2.6c234809.jpg";